import {
    DELETE_PLAYER_REQUEST,
    DELETE_PLAYER_SUCCESS,
    DELETE_PLAYER_FAIL,
    DELETE_PLAYER_RESET,
    BULK_DELETE_PLAYERS_REQUEST,
    BULK_DELETE_PLAYERS_SUCCESS,
    BULK_DELETE_PLAYERS_FAIL,
    BULK_DELETE_PLAYERS_RESET,
    GET_PLAYER_PROFILE_REQUEST,
    GET_PLAYER_PROFILE_SUCCESS,
    GET_PLAYER_PROFILE_FAIL,
    GET_PLAYER_PROFILE_RESET,
    GET_PLAYER_SUMMARY_REQUEST,
    GET_PLAYER_SUMMARY_SUCCESS,
    GET_PLAYER_SUMMARY_FAIL,
    GET_PLAYER_SUMMARY_RESET,
    GET_PLAYER_TRANSACTIONS_REQUEST,
    GET_PLAYER_TRANSACTIONS_SUCCESS,
    GET_PLAYER_TRANSACTIONS_FAIL,
    GET_PLAYER_TRANSACTIONS_RESET,
    GET_PLAYER_ANALYTICS_REQUEST,
    GET_PLAYER_ANALYTICS_SUCCESS,
    GET_PLAYER_ANALYTICS_FAIL,
    GET_PLAYER_ANALYTICS_RESET,
    GET_PLAYER_CLUBS_REQUEST,
    GET_PLAYER_CLUBS_SUCCESS,
    GET_PLAYER_CLUBS_FAIL,
    GET_PLAYER_CLUBS_RESET,
    GET_PLAYER_REFERRALS_REQUEST,
    GET_PLAYER_REFERRALS_SUCCESS,
    GET_PLAYER_REFERRALS_FAIL,
    GET_PLAYER_REFERRALS_RESET,
    FREEZE_PLAYER_REQUEST,
    FREEZE_PLAYER_SUCCESS,
    FREEZE_PLAYER_FAIL,
    FREEZE_PLAYER_RESET,
    GET_PLAYER_PHONE_REQUEST,
    GET_PLAYER_PHONE_SUCCESS,
    GET_PLAYER_PHONE_FAIL,
    GET_PLAYER_PHONE_RESET,
    LIST_PLAYERS_REQUEST,
    LIST_PLAYERS_SUCCESS,
    LIST_PLAYERS_FAIL,
    LIST_PLAYERS_RESET,
    ASSIGN_PLAYER_CLUB_REQUEST,
    ASSIGN_PLAYER_CLUB_SUCCESS,
    ASSIGN_PLAYER_CLUB_FAIL,
    ASSIGN_PLAYER_CLUB_RESET,
    REMOVE_PLAYER_CLUB_REQUEST,
    REMOVE_PLAYER_CLUB_SUCCESS,
    REMOVE_PLAYER_CLUB_FAIL,
    REMOVE_PLAYER_CLUB_RESET,
    GET_PLAYER_REMARKS_REQUEST,
    GET_PLAYER_REMARKS_SUCCESS,
    GET_PLAYER_REMARKS_FAIL,
    GET_PLAYER_REMARKS_RESET,
    UPDATE_PLAYER_REMARKS_REQUEST,
    UPDATE_PLAYER_REMARKS_SUCCESS,
    UPDATE_PLAYER_REMARKS_FAIL,
    UPDATE_PLAYER_REMARKS_RESET,
} from '../constants/playerConstants';

// ============================================================================
// PLAYER PROFILE REDUCER
// ============================================================================
export const playerProfileReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_PROFILE_REQUEST:
            return { loading: true };
        case GET_PLAYER_PROFILE_SUCCESS:
            return { loading: false, player: action.payload };
        case GET_PLAYER_PROFILE_FAIL:
            return { loading: false, error: action.payload };
        case GET_PLAYER_PROFILE_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// PLAYER FINANCIAL SUMMARY REDUCER
// ============================================================================
export const playerSummaryReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_SUMMARY_REQUEST:
            return { loading: true };
        case GET_PLAYER_SUMMARY_SUCCESS:
            return { loading: false, summary: action.payload };
        case GET_PLAYER_SUMMARY_FAIL:
            return { loading: false, error: action.payload };
        case GET_PLAYER_SUMMARY_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// PLAYER TRANSACTIONS REDUCER
// ============================================================================
export const playerTransactionsReducer = (state = { transactions: [], pagination: {} }, action) => {
    switch (action.type) {
        case GET_PLAYER_TRANSACTIONS_REQUEST:
            return { ...state, loading: true };
        case GET_PLAYER_TRANSACTIONS_SUCCESS:
            return {
                loading: false,
                transactions: action.payload.transactions,
                pagination: action.payload.pagination,
            };
        case GET_PLAYER_TRANSACTIONS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case GET_PLAYER_TRANSACTIONS_RESET:
            return { transactions: [], pagination: {} };
        default:
            return state;
    }
};

// ============================================================================
// PLAYER ANALYTICS REDUCER
// ============================================================================
export const playerAnalyticsReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_ANALYTICS_REQUEST:
            return { loading: true };
        case GET_PLAYER_ANALYTICS_SUCCESS:
            return { loading: false, analytics: action.payload };
        case GET_PLAYER_ANALYTICS_FAIL:
            return { loading: false, error: action.payload };
        case GET_PLAYER_ANALYTICS_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// PLAYER CLUBS REDUCER
// ============================================================================
export const playerClubsReducer = (state = { clubs: [] }, action) => {
    switch (action.type) {
        case GET_PLAYER_CLUBS_REQUEST:
            return { ...state, loading: true };
        case GET_PLAYER_CLUBS_SUCCESS:
            return {
                loading: false,
                clubs: action.payload.clubs,
                totalClubs: action.payload.totalClubs,
            };
        case GET_PLAYER_CLUBS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case GET_PLAYER_CLUBS_RESET:
            return { clubs: [] };
        default:
            return state;
    }
};

// ============================================================================
// PLAYER REFERRALS REDUCER
// ============================================================================
export const playerReferralsReducer = (state = { referrals: [] }, action) => {
    switch (action.type) {
        case GET_PLAYER_REFERRALS_REQUEST:
            return { ...state, loading: true };
        case GET_PLAYER_REFERRALS_SUCCESS:
            return {
                loading: false,
                referrals: action.payload.referrals,
                count: action.payload.count,
                bonusGrantedCount: action.payload.bonusGrantedCount,
            };
        case GET_PLAYER_REFERRALS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case GET_PLAYER_REFERRALS_RESET:
            return { referrals: [] };
        default:
            return state;
    }
};

// ============================================================================
// FREEZE PLAYER REDUCER
// ============================================================================
export const freezePlayerReducer = (state = {}, action) => {
    switch (action.type) {
        case FREEZE_PLAYER_REQUEST:
            return { loading: true };
        case FREEZE_PLAYER_SUCCESS:
            return { loading: false, success: true, result: action.payload };
        case FREEZE_PLAYER_FAIL:
            return { loading: false, error: action.payload };
        case FREEZE_PLAYER_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// PLAYER PHONE REDUCER (Sensitive Data)
// ============================================================================
export const playerPhoneReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_PHONE_REQUEST:
            return { loading: true };
        case GET_PLAYER_PHONE_SUCCESS:
            return { loading: false, phoneData: action.payload };
        case GET_PLAYER_PHONE_FAIL:
            return { loading: false, error: action.payload };
        case GET_PLAYER_PHONE_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// LIST PLAYERS REDUCER
// ============================================================================
export const listPlayersReducer = (state = { players: [], pagination: {} }, action) => {
    switch (action.type) {
        case LIST_PLAYERS_REQUEST:
            return { ...state, loading: true };
        case LIST_PLAYERS_SUCCESS:
            return {
                loading: false,
                players: action.payload.players,
                pagination: action.payload.pagination,
            };
        case LIST_PLAYERS_FAIL:
            return { ...state, loading: false, error: action.payload };
        case LIST_PLAYERS_RESET:
            return { players: [], pagination: {} };
        default:
            return state;
    }
};

// ============================================================================
// ASSIGN PLAYER CLUB REDUCER
// ============================================================================
export const assignPlayerClubReducer = (state = {}, action) => {
    switch (action.type) {
        case ASSIGN_PLAYER_CLUB_REQUEST:
            return { loading: true };
        case ASSIGN_PLAYER_CLUB_SUCCESS:
            return { loading: false, success: true, result: action.payload };
        case ASSIGN_PLAYER_CLUB_FAIL:
            return { loading: false, error: action.payload };
        case ASSIGN_PLAYER_CLUB_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// REMOVE PLAYER CLUB REDUCER
// ============================================================================
export const removePlayerClubReducer = (state = {}, action) => {
    switch (action.type) {
        case REMOVE_PLAYER_CLUB_REQUEST:
            return { loading: true };
        case REMOVE_PLAYER_CLUB_SUCCESS:
            return { loading: false, success: true, result: action.payload };
        case REMOVE_PLAYER_CLUB_FAIL:
            return { loading: false, error: action.payload };
        case REMOVE_PLAYER_CLUB_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// GET PLAYER REMARKS REDUCER
// ============================================================================
export const playerRemarksReducer = (state = {}, action) => {
    switch (action.type) {
        case GET_PLAYER_REMARKS_REQUEST:
            return { loading: true };
        case GET_PLAYER_REMARKS_SUCCESS:
            return { loading: false, remarks: action.payload.remarks, playerName: action.payload.playerName };
        case GET_PLAYER_REMARKS_FAIL:
            return { loading: false, error: action.payload };
        case GET_PLAYER_REMARKS_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// UPDATE PLAYER REMARKS REDUCER
// ============================================================================
export const updatePlayerRemarksReducer = (state = {}, action) => {
    switch (action.type) {
        case UPDATE_PLAYER_REMARKS_REQUEST:
            return { loading: true };
        case UPDATE_PLAYER_REMARKS_SUCCESS:
            return { loading: false, success: true, remarks: action.payload.remarks };
        case UPDATE_PLAYER_REMARKS_FAIL:
            return { loading: false, error: action.payload };
        case UPDATE_PLAYER_REMARKS_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// DELETE PLAYER REDUCER
// ============================================================================
export const deletePlayerReducer = (state = {}, action) => {
    switch (action.type) {
        case DELETE_PLAYER_REQUEST:
            return { loading: true };
        case DELETE_PLAYER_SUCCESS:
            return { loading: false, success: true, playerId: action.payload.playerId };
        case DELETE_PLAYER_FAIL:
            return { loading: false, error: action.payload };
        case DELETE_PLAYER_RESET:
            return {};
        default:
            return state;
    }
};

// ============================================================================
// BULK DELETE PLAYERS REDUCER
// ============================================================================
export const bulkDeletePlayersReducer = (state = {}, action) => {
    switch (action.type) {
        case BULK_DELETE_PLAYERS_REQUEST:
            return { loading: true };
        case BULK_DELETE_PLAYERS_SUCCESS:
            return {
                loading: false,
                success: true,
                deletedCount: action.payload.deletedCount,
                skipped: action.payload.skipped || [],
            };
        case BULK_DELETE_PLAYERS_FAIL:
            return { loading: false, error: action.payload };
        case BULK_DELETE_PLAYERS_RESET:
            return {};
        default:
            return state;
    }
};
